import { render, staticRenderFns } from "./ApplicantIdentity.vue?vue&type=template&id=18b1a305&scoped=true"
import script from "./ApplicantIdentity.vue?vue&type=script&lang=js"
export * from "./ApplicantIdentity.vue?vue&type=script&lang=js"
import style0 from "./ApplicantIdentity.vue?vue&type=style&index=0&id=18b1a305&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b1a305",
  null
  
)

export default component.exports